import * as types from "@/redux/types";

const initialState = {
    activated: false,
    created: false,
    data: {
        data: [],
        noData: false,
        pagination: {},
    },
    deactivated: false,
    details: {},
    error: null,
    lastActivated: {},
    lastCreated: {},
    lastDeactivated: {},
    lastUpdated: {},
    resetPassword: false,
    updated: false,
};

export const adminsReducer = (state = initialState, action) => {
    const {
        payload,
        type,
    } = action;

    const {
        data,
        error,
    } = payload || {};

    switch (type) {
        case types.ACTIVATE_ADMIN_SUCCESS:
            return {
                ...state,
                activated: true,
                lastActivated: data,
            };

        case types.ADMINS_FAIL:
            return {
                ...state,
                error,
            };

        case types.ADMINS_REQUEST:
            return {
                ...state,
                activated: false,
                created: false,
                deactivated: false,
                error: null,
                resetPassword: false,
                updated: false,
            };

        case types.CREATE_ADMIN_SUCCESS:
            return {
                ...state,
                created: true,
                lastCreated: data,
            };

        case types.DEACTIVATE_ADMIN_SUCCESS:
            return {
                ...state,
                deactivated: true,
                lastDeactivated: data,
            };

        case types.GET_ADMIN_SUCCESS:
            return {
                ...state,
                details: data,
            };

        case types.GET_ADMINS_SUCCESS:
            return {
                ...state,
                data,
            };

        case types.RESET_ADMIN_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPassword: true,
            };

        case types.UPDATE_ADMIN_SUCCESS:
            return {
                ...state,
                lastUpdated: data,
                updated: true,
            };

        default: return state;
    }
};
